export type ConflictValidationType =
  | 'UniqueTractor'
  | 'UniqueTrailer'
  | 'UniqueDriver'
  | 'OutOfServiceTractor'
  | 'InactiveTractor'

export type ConflictError<T> = { type: ConflictValidationType; value: string; items: T[] }
export type ConflictInfo<T> = { conflictingItems: T[]; errors: ConflictError<T>[] }

export abstract class ConflictValidation<T> {
  constructor(public type: ConflictValidationType) {}

  //return false if the item is invalid
  abstract validate(itemA: T, itemB: T): boolean
  abstract getErrorMessages(items: T[]): string
  getSingleErrorMessage = (item: T) => this.getErrorMessages([item])
  collectErrors = (items: T[]) => {
    if (!items.length) return
    if (items.length === 1) return this.getSingleErrorMessage(items[0])
    return this.getErrorMessages(items)
  }
}

export class ConflictValidators<T> {
  validatorsByType = {} as Record<ConflictValidationType, ConflictValidation<T>>
  constructor(public validators: ConflictValidation<T>[]) {
    this.validatorsByType = validators.reduce(
      (result, validator) => {
        if (!result[validator.type]) {
          result[validator.type] = validator
        }
        return result
      },
      {} as Record<ConflictValidationType, ConflictValidation<T>>
    )
  }

  getInvalidItems = (item: T, itemsToCompare: T[]): ConflictInfo<T> => {
    const validations = {} as Record<ConflictValidationType, T[]>
    const conflictingItems: T[] = []
    itemsToCompare.map((item2) => {
      let valid = true
      this.validators.forEach((validator) => {
        if (!validator.validate(item, item2)) {
          if (!validations[validator.type]) {
            validations[validator.type] = []
          }
          validations[validator.type].push(item2)
          valid = false
        }
      })
      if (!valid) {
        conflictingItems.push(item2)
      }
    })
    return {
      conflictingItems,
      errors: (Object.entries(validations) as Array<[ConflictValidationType, T[]]>)
        .map(([type, invalidItems]) => ({
          type: type,
          value: this.validatorsByType[type].collectErrors(invalidItems),
          items: invalidItems,
        }))
        .filter((x): x is ConflictError<T> => x.value !== undefined),
    }
  }
}
